import { Divider, Paper } from '@mui/material';
import { MemreAccordion, MemreButton, MemreFlexBox } from 'components/core';
import EmbedBlock from './EmbedBlock';
import EmptyBlock from './EmptyBlock';
import ImageBlock from './ImageBlock';
import SoundBlock from './SoundBlock';
import TextBlock from './TextBlock';
import VideoBlock from './VideoBlock';

export default function InstructionalBlocks({ item, dragHandle }) {
  const { id } = item;

  const disabled = id.includes('placeholder');

  const Block =
    {
      text: TextBlock,
      sound: SoundBlock,
      image: ImageBlock,
      embed: EmbedBlock,
      video: VideoBlock,
    }[item.type] || EmptyBlock;

  const title = `${item.position}. ${
    {
      embed: 'Embed',
      text: 'Text',
      sound: 'Sound',
      image: 'Image',
      video: 'Video',
    }[item.type] || 'Select Note Type'
  }`;

  return (
    <Paper
      component="form"
      key={id}
      sx={{
        p: '0 8px 0 4px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #bbb',
        opacity: disabled ? 0.3 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        height: '100%',
      }}
    >
      <MemreFlexBox direction="column" sx={{ height: '100%', p: 1 }} justify="center">
        {dragHandle}
      </MemreFlexBox>
      <Divider sx={{ height: '100%', ml: 0.5, mr: 0 }} orientation="vertical" />
      <MemreFlexBox sx={{ flex: 1, height: '100%' }}>
        <MemreAccordion id={id + item.open} isOpen={item.open} handleOpen={item.setOpen} title={title}>
          <Block item={item} />
        </MemreAccordion>
      </MemreFlexBox>
      <Divider sx={{ height: '100%', mr: 1, ml: 0 }} orientation="vertical" />
      <MemreFlexBox sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
        <MemreButton variant="icon" iconName="trash" onClick={item.delete} />
      </MemreFlexBox>
    </Paper>
  );
}
